<template>
    <div class="row mt-4" v-if="triggers && triggers.length > 0">
        <div class="col-sm-12">
            <div class="ix-table-box">
                <table class="ix-table ix-table-sm">
                    <thead>
                        <th>Déclencheur</th>
                        <th class="text-center">Nouvelle valeur de référence</th>
                        <th></th>
                    </thead>
                    <tbody>
                        <template v-if="!loading">
                            <tr v-for="(trigger, index) in triggers" :key="index" >
                                <td>
                                    <span v-if="trigger.type == TYPE_CALENDAR">Calendaire</span>
                                    <span v-if="trigger.type == TYPE_COUNTER">Compteur</span>
                                    <div>
                                        <span v-if="trigger.type == TYPE_CALENDAR">{{ trigger.origin_at | formatDate('DD MMM YYYY') }}</span>
                                        <span v-if="trigger.type == TYPE_COUNTER">Valeur act. {{ trigger.counter.actual_value }} {{ trigger.counter.unit }}</span>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <span class="ix-state bordered red" v-if="temporaries && getTemporary(temporaries, trigger.id).length == 0">Non renseignée</span>
                                    <template v-if="temporaries && getTemporary(temporaries, trigger.id).length > 0">
                                        <span v-if="trigger.type == TYPE_COUNTER">
                                            {{ getTemporary(temporaries, trigger.id)[0].reset_value }} {{ trigger.counter.unit }} au
                                        </span>
                                            {{ getTemporary(temporaries, trigger.id)[0].reset_at | formatDate('DD MMM YYYY')  }} 
                                    </template>
                                </td>
                                <td class="text-right" v-if="stateInspection != 4">
                                    <button class="ix-btn ix-btn-icon" @click="openModal(trigger)" v-if="temporaries && getTemporary(temporaries, trigger.id).length == 0 && (stateInspection <= 2 || stateInspection <= 3)" ><i class="fas fa-marker"></i></button>
                                    <button class="ix-btn ix-btn-icon" @click="openModal(trigger, true)" v-if="temporaries && getTemporary(temporaries, trigger.id).length > 0 && (stateInspection <= 2 || stateInspection <= 3)" ><i class="fas fa-edit"></i></button>
                                </td>
                            </tr>
                        </template>
                        <tr v-if="loading">
                            <td colspan="3" class="text-center">
                                <i class="far fa-circle-notch fa-spin"></i> 
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="modal fade" id="temporariesModal" tabindex="-1" aria-labelledby="temporariesModal" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content" v-if="currentTrigger && currentTrigger != null">
                    <div class="modal-header">
                        <h5 class="modal-title"><i class="far fa-balance-scale-left"></i> Nouvelle valeur de référence</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <i class="fal fa-times"></i>
                        </button>
                    </div>
                     <div class="modal-body">
                         <div class="row">
                             <div class="col-sm-12">
                                 <div class="form-group">
                                     <label for="reset_at" class="required">Date de relevé</label>
                                     <v-date-picker v-model="form.reset_at" mode="datetime" :timezone="timezone" is24hr :popover="{ visibility: 'click' }">
                                            <template v-slot="{ inputValue, inputEvents }">
                                            <input
                                                class="form-control"
                                                :value="inputValue"
                                                v-on="inputEvents"
                                                required="true"
                                                name="reset_at"
                                                id="reset_at"
                                            />
                                            </template>
                                    </v-date-picker>
                                 </div>

                                 <div class="form-group" v-if="currentTrigger.type == TYPE_COUNTER">
                                     <label for="reset_value" class="required">Valeur lue</label>
                                     <input type="number" v-model="form.reset_value" step="0.001" class="form-control" name="reset_value" id="reset_value" required>
                                 </div>

                                 <div class="alert alert-danger" v-if="error && error != null">{{ error }}</div>
                             </div>
                         </div>
                     </div>
                     <div class="modal-footer">
                        <button type="submit" class="ix-btn green" v-bind:disabled="!formIsValid()" @click="saveTemporary()">
                            <span v-if="!loadingForm">Enregistrer</span>
                            <span  v-if="loadingForm"><i class="far fa-circle-notch fa-spin"></i></span>
                        </button>
                </div>
                </div>
            </div>
        </div>
    </div>
    
</template>


<script>


export default {
    name: 'Trigger',
    props: ['url', 'urlTemporary', 'inspection'],
    data() {
        return {
            loading: false,
            loadingForm: false,
            TYPE_CALENDAR : 1,
            TYPE_COUNTER : 2,
            form : {
                reset_at : new Date(),
                reset_value : null,
            },
            currentTrigger: null, 
            timezone : '',
            error: null,
            triggers: [],
            stateInspection: null,
            temporary: null,
            editTemporary: false,
            temporaries: [],
        }
    },
    methods: {
        openModal(trigger, editTemporary = false){
            this.error = null;
            this.currentTrigger = trigger;
            this.editTemporary = editTemporary;
            if(this.editTemporary){
                this.temporary = this.getTemporary(this.temporaries, trigger.id)[0];
                if(this.currentTrigger.counter_id != null){
                    this.form.reset_value = this.temporary.reset_value
                }
                this.form.reset_at = this.temporary.reset_at;
            }
            $('#temporariesModal').modal()
        },
        formIsValid(){
            if(this.currentTrigger.counter_id != null){
                return this.form.reset_at != null && (this.form.reset_value != null && this.form.reset_value != '')
            } else {
                return this.form.reset_at != null;
            }
        },
        saveTemporary(){
            this.loadingForm = true;
            this.error = null;
            fetch(this.urlTemporary +  (this.editTemporary && this.temporary && this.temporary != null ? '/' + this.temporary.id : ''), {
                    ...{
                        method: this.editTemporary && this.temporary != null ? 'PUT' : 'POST'
                    },
                    ...this.getHttpJsonRequestHeaders(),
                    ...{
                        body: JSON.stringify({
                            counter_id : this.currentTrigger.type == this.TYPE_COUNTER ? this.currentTrigger.counter_id : null,
                            trigger_id : this.currentTrigger.id,
                            reset_at : this.moment(this.form.reset_at).format('L LT'),
                            reset_value : this.currentTrigger.type == this.TYPE_COUNTER ? this.form.reset_value : null,
                            inspection_id : this.inspection.id,
                            temporary_id : this.temporary != null ? this.temporary.id : null
                        })
                    }
            }).then((response) => {
                if(response.status == 200){
                    response.json().then((data) => {
                        if(!data.reload){
                             if(this.currentTrigger.type == this.TYPE_COUNTER)
                                this.form.reset_value = null;

                            if(this.temporary != null){
                                this.temporary = null;
                                this.editTemporary = false;
                            }

                            $('#temporariesModal').modal('hide')
                            this.getData();
                        } else {
                            window.location.reload();
                        }

                    })
                } else {
                    response.json().then((error) => {
                        this.error = error.message;
                    })
                } 
                this.loadingForm = false;  
            }).catch((error) => {
                console.log(error);
                this.loadingForm = false;  
            });
        },
        async getData(){
            this.loading = true;
             fetch(this.url + '?inspection_id='+ this.inspection.id, {
                ...{
                    method: 'GET'
                },
                ...this.getHttpJsonRequestHeaders(),
                }).then((response) => {
                    if (response.status == 200) {
                        response.json().then((data) => {
                            if (data) {
                                this.triggers = data.triggers;
                                this.stateInspection = data.currentState;
                                this.temporaries = data.temporaries;
                            }
                        })
                        
                        this.loading = false;
                    }
                }).catch((error) => {
                    this.loading = false;
                });
        },
        getTemporary(temporaries, triggerId){
            return temporaries.filter(temporary => temporary.trigger_id == triggerId);
        }
    },

   async mounted(){
        await this.getData();
    }
}
</script>
